import React, { useState, useEffect } from "react";
import { Container, Typography, Paper, Button, Box } from "@mui/material";
import WalletBalance from "../components/Header/Wallet/WalletBalance";
import WalletTransaction from "../components/Header/Wallet/WalletTransaction";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PaymentsIcon from '@mui/icons-material/Payments';
import { investorApi } from "../api/api";
import SecondaryButton from "../components/common/SecondaryButton";
import GradientButton from "../components/common/GradiantButton";

const Wallet = () => {
  const theme = useSelector((data) => data.themeValue.colors);
  const themeMode = useSelector((data) => data.themeValue.theme);
  const [walletAmount, setWalletAmount] = useState(0);
  const navigate = useNavigate();
  const userId = useSelector((state) => state.user.userId);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchWalletBalance = async () => {
      try {
        if (!userId) {
          setLoading(false);
          return;
        }
        const response = await investorApi.getWalletBalance(userId);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setWalletAmount(response.data[0].Balance);
        } else {
          setWalletAmount(0);
        }
      } catch (error) {
        console.error("Error fetching wallet balance:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchWalletBalance();
  }, [userId]);

  return (
    <Container
     
      maxWidth={false}
      disableGutters
      sx={{ mt: 4, display: "flex", justifyContent: "center", paddingRight: "5px", paddingLeft: "5px",minHeight:"90vh" }}
    >
      <Paper
        elevation={4}
        sx={{
          width: {
            xs: "100%", // mobile
            sm: "80%",  // tablet
            md: "80%",  // desktop
          },
          p: {         // responsive padding
            xs: 1,     // 1 * 8px = 8px (default MUI spacing)
            sm: 3,     // 3 * 8px = 24px
            md: 4,     // 4 * 8px = 32px
          },
          borderRadius: 4,
          background: theme.background,
          boxShadow:
            themeMode === "light"
              ? "0px 4px 12px rgba(0, 0, 0, 0.15)"
              : "0px 4px 12px rgba(255, 255, 255, 0.1)",
        }}
      >

        {/* Add this Button component right before WalletBalance */}
        {walletAmount > 0 && (
        <Box sx={{ textAlign: "end", paddingRight: "5px" }}>
          <GradientButton
            text="Withdraw Funds"
            startIcon={<PaymentsIcon />}
            onClick={() => navigate("/withdraw", { state: { walletAmount, userId } })}
            style={{
              width: "auto",
              fontSize: {
                xs: '10px',  
                sm: '12px',  
                md: '15px', 
                lg: '17px', 
              },
              ml: { sm: 3, md: 4 },
              mt: { xs: 2, sm: 0 },
              display: "inline-flex",
              alignItems: "center",
              borderRadius: 2,
              borderRadius:5,
            }}
          />
        </Box>
        )}

        <WalletBalance walletAmount={walletAmount} />
        <WalletTransaction />
      </Paper>
    </Container>
  );
};

export default Wallet;